jQuery(document).ready(function () {

    const [red, green, blue, transparent] = [80, 100, 150, 1]
    const section1 = document.querySelector('.sticky-top-font-gen-field')

    window.addEventListener('scroll', () => {
        let y = 1 + (window.scrollY ) / 500
        let custom = 500 / (1 + (window.scrollY))
        const [r, g, b] = [red/y, green/y, blue/y].map(Math.round)
        section1.style.backgroundColor = `rgb(${r}, ${g}, ${b}, ${transparent/custom})`

    })


    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    let inputField = document.querySelector('#fontGenField')
    let outputFields = document.querySelectorAll('.font-output');

    if (inputField.value && inputField !== ""){
        outputFields.forEach((outputField) => {
            outputField.innerHTML = inputField.value
        })
    }

    inputField.addEventListener('keyup', (e)=> {
        outputFields.forEach((outputField) => {
            if (inputField.value && inputField !== "") {
                outputField.innerHTML = inputField.value
            }
        })
    })

    let increaseFont = document.querySelector("#increase-font")
    let decreaseFont = document.querySelector("#decrease-font")
    let resetFont = document.querySelector("#reset-font")

    increaseFont.addEventListener('click', (e) => {
        outputFields.forEach((outputField) => {
            let currentFontSize = parseInt(window.getComputedStyle(outputField).fontSize);
            if (currentFontSize < 70){
                outputField.style.fontSize = currentFontSize + 10 + "px";
            }
        });
    });
    decreaseFont.addEventListener('click', (e) => {
        outputFields.forEach((outputField) => {
            let currentFontSize = parseInt(window.getComputedStyle(outputField).fontSize);
            console.log(currentFontSize)
            if (currentFontSize > 22){
                outputField.style.fontSize = currentFontSize - 10 + "px";
            }
        });
    });

    resetFont.addEventListener('click', (e) => {
        outputFields.forEach((outputField) => {
            outputField.style.fontSize = "42px";
        });
    });

})
